export default {"src":"/_next/static/media/circled-check.6a62ab72.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};